import { Helmet } from 'react-helmet-async';

const SEOHead = ({
    title,
    description,
    path = '',
    image = '/img/LogoDuoaColor512.png'
}) => {
    const siteUrl = 'https://duoacolor.com';
    const fullUrl = `${siteUrl}${path}`;
    const fullImage = `${siteUrl}${image}`;

    return (
        <Helmet>
            <title>{title}</title>
            <meta name="description" content={description} />
            <link rel="canonical" href={fullUrl} />

            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:url" content={fullUrl} />
            <meta property="og:image" content={fullImage} />

            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={fullImage} />
        </Helmet>
    );
};

export default SEOHead;
